import React, { PureComponent } from 'react'
import styles from './TopicList.scss'
import config from '@public-config'
import CloseIcon from '@material-ui/icons/Close'
import Button from '@material-ui/core/Button'
import FasCheck from '@components/Icons/font-awesome/FasCheck'
import AddTopic from './AddTopic'

const DEFAULT_TOPIC_ID = 'topic.640288'

class TopicList extends PureComponent {
  state = {
    selected: [],
  }

  componentDidMount() {
    const { topicList } = this.props
    this.setState({
      selected: topicList.filter((item) => item.d === 0).map((item) => item.postID),
    })
  }

  render() {
    const { onClose, topicList } = this.props
    return (
      <div className="topicList">
        <style jsx>{styles}</style>
        <div className="topicListHeader">
          <div className="btnClose" onClick={onClose}>
            <CloseIcon className="iconClose" />
          </div>
          <div className="title">選擇收藏清單</div>
          <div className="right" />
        </div>
        <div className="topicListContent">
          <AddTopic onTopicAdded={this._onClickSelectItem} />
          {topicList.map((item) => {
            const topicId = item.postID
            const isSelected = this.state.selected.includes(topicId)
            return (
              <div
                className="topicItem"
                style={{ backgroundColor: isSelected === false ? '#fff' : '#f8f8f8' }}
                key={topicId}
                onClick={() => this._onClickSelectItem({ topicId })}
              >
                <div className="coverOuter">
                  <div className="cover">
                    {item.cover && <img src={`${config.imageBaseUrl}/${item.cover}`} />}
                  </div>
                  <span>{item.title}</span>
                  <span>{topicId === DEFAULT_TOPIC_ID ? '(預設)' : ''}</span>
                  {item.privacy !== 0 && (
                    <img className="iconLock" src={`${config.imageAssetUrl}/icon/lock-grey.png`} />
                  )}
                </div>
                <div className="btnCheckmark">
                  {isSelected ? (
                    <div className="checkmark">
                      <FasCheck className="iconCheck" />
                    </div>
                  ) : (
                    <div className="unselect" />
                  )}
                </div>
              </div>
            )
          })}
        </div>
        <div className="topicListFooter">{this._renderSaveButton()}</div>
      </div>
    )
  }

  _renderSaveButton = () => {
    if (this.state.selected.length > 0) {
      return (
        <Button className="btnSave" onClick={this._onClickSave}>
          存入收藏清單
        </Button>
      )
    }
    return this.props.isSaved ? (
      <Button className="btnSave" onClick={this._onClickSave}>
        取消收藏
      </Button>
    ) : (
      <Button className="btnSave" onClick={this._onClickSaveDefaultTopic}>
        存入預設收藏清單
      </Button>
    )
  }

  _onClickSelectItem = ({ topicId }) => {
    this.setState((prev) => {
      if (prev.selected.includes(topicId)) {
        return {
          ...prev,
          selected: prev.selected.filter((id) => id !== topicId),
        }
      }
      return {
        ...prev,
        selected: [...prev.selected, topicId],
      }
    })
  }

  _onClickSave = (e) => {
    const { setPostToTopic, onClose, topicList } = this.props
    setPostToTopic({
      topicList: topicList.map((item) =>
        this.state.selected.includes(item.postID) ? { ...item, d: 0 } : { ...item, d: 1 },
      ),
    })
    onClose(e)
  }

  _onClickSaveDefaultTopic = (e) => {
    const { setPostToTopic, onClose, topicList } = this.props
    setPostToTopic({
      topicList: topicList.map((item, idx) => (idx === 0 ? { ...item, d: 0 } : item)),
    })
    onClose(e)
  }
}

export default TopicList
